import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import PhilosophySection from './components/PhilosophySection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ExpertiseSection />
      <CapabilitiesSection />
      <PhilosophySection />
      <ContactSection />
    </main>
  );
}